import { getSocialLinks as getSocialLinksRepo } from '../../../data/repositories/socialLinkRepository.js';

export const fetchSocialLinks = (businessId) => getSocialLinksRepo(businessId);
